import React from "react";
import { connect } from "react-redux";
import { notifyGeneralInfo } from "../../actions";
import axios from "axios";
import { withRouter } from "react-router-dom";

const token = localStorage.getItem('authToken');

class EditTopBanner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      textInput: null,
      userName: "",
      submissionStatus: null,
      currentImageUrl: null,
      submeet: false,
      errors: [],
      maxSize: 5 * 1024 * 1024, // 5MB in bytes
      id: null,
      isLoading: true,
      imageUrl: "",
      bannerUrl: "",  // New state property for the URL
    };
  }

  async componentDidMount() {
    const { match } = this.props;
    if (match && match.params && match.params.id) {
      const { id } = match.params;
      this.setState({ id });
      await this.fetchData(id);
    } else {
      console.error("No match params found.");
    }
  }

  fetchData = async (id) => {
    console.log("Fetching data for ID:", id);
    try {
      const response = await axios.get(`https://brand.aasmo.in/api/admin/get-banner/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response) {
        console.log(response.data);
        this.setState({
          userName: response.data?.bannerName || "",
          imageUrl: response.data?.image || "",
          currentImageUrl: response?.data?.image,   
          pincode: response.data.pincode,
          bannerUrl: response?.data?.url || "",  // Set the URL from the fetched data
          isLoading: false,
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      this.setState({ isLoading: false });
    }
  };

  handleChange = (e) => {
    const files = Array.from(e.target.files);
    const errors = [];

    files.forEach((file) => {
      if (file.size > this.state.maxSize) {
        errors.push(`${file.name} is too large, please select a file smaller than 5MB.`);
        this.setState({ errors });
        return;
      }

      const reader = new FileReader();
      reader.onload = (event) => {
        this.setState({
          textInput: file,
          currentImageUrl: URL.createObjectURL(file),
        });
      };
      reader.readAsDataURL(file);
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { id } = this.props.match.params;
    this.setState({ submeet: true });

    const { textInput, userName, pincode, imageUrl, bannerUrl } = this.state;

    if (!userName) {
      return;
    }

    try {
      const formData = new FormData();
      if (textInput) {
        formData.append("image", textInput);
      } else {
        formData.append("image", imageUrl);
      }
      formData.append("bannerName", userName);
      formData.append("pincode", pincode);
      formData.append("url", bannerUrl);  // Include the URL in the form data

      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        }
      };

      const response = await axios.put(`https://brand.aasmo.in/api/admin/update-banner/${id}`, formData, config);

      if (response.status === 200) {
        this.setState({ submissionStatus: 'success' });
        setTimeout(() => {
          this.props.history.push ("/topbannerlist");
        }, 2000);
      }

      console.log(response, "==>res");
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    const { userName, currentImageUrl, submeet, pincode, bannerUrl, errors, submissionStatus, isLoading } = this.state;
    const isNameValid = userName.trim().length > 0;

    if (isLoading) {
      return <div>Loading...</div>;
    }

    return (
      <div className="col-md-12">
        <div className="card">
          <div className="header">
            <h2>Edit Top Banner</h2>
          </div>
          <div className="body">
            <form onSubmit={this.handleSubmit}>
              <div className="form-group">
                <label>Image</label>
                {currentImageUrl && (
                  <div>
                    <img src={currentImageUrl} alt="Current" style={{ width: '100px', marginBottom: '10px' }} />
                  </div>
                )}
                <input
                  type="file"
                  className="form-control"
                  name="textInput"
                  onChange={this.handleChange}
                />
                <br />
                {errors.length > 0 && (
                  <div className="alert alert-danger" role="alert">
                    {errors.map((error, index) => (
                      <div key={index}>{error}</div>
                    ))}
                  </div>
                )}
              </div>

              <div className="form-group">
                <label>Name</label>
                <input
                  className={`form-control ${!isNameValid && submeet && "parsley-error"}`}
                  value={userName}
                  name="userName"
                  required=""
                  type="text"
                  onChange={(e) => this.setState({ userName: e.target.value })}
                />
                {!isNameValid && submeet && (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">This value is required.</li>
                  </ul>
                )}
              </div>

              <div className="form-group">
                <label>URL</label>  {/* New URL input field */}
                <input
                  className="form-control"
                  value={bannerUrl}
                  name="bannerUrl"
                  type="text"
                  onChange={(e) => this.setState({ bannerUrl: e.target.value })}
                />
              </div>

              <div className="form-group">
                <label>Pincode (Optional)</label>
                <input
                  className="form-control"
                  value={pincode}
                  name="pincode"
                  type="text"
                  onChange={(e) => this.setState({ pincode: e.target.value })}
                />
              </div>

              {submissionStatus === "success" && (
                <div className="alert alert-success" role="alert">
                  Form submitted successfully!
                </div>
              )}

              <button className="btn btn-primary" type="submit">
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default connect(mapStateToProps, { notifyGeneralInfo })(withRouter(EditTopBanner));
